import axios from "axios";
import { Component } from "react";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class ProposalServices extends Component {
  static async getProposalCount(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_ADVANCE_URL}/template?code=proposal_count`)
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async deleteProposalById(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/delete?proposalId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async editGeneratedProposal(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/edit?proposalId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async generateProposal(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/generateProposalForm?proposalId=${id}`);
    try {
      let resp = await axios.post(
        url,
        {},
        {
          headers: header,
        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      return error;
    }

  }

  static async getNobListing(occupationCode) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/master/nob?occ=${occupationCode}`);
    let resp = await axios.get(
      url,
      { headers: header }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getProposalListing(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/record/read/template?code=proposal_list`);
    let resp = await axios.post(
      url,
      payload,
      { headers: header }
    );
    let response = BaseWebService.listingQuotationResponseFromWeb(resp.data);
    return response;
  }

  static async changeOTPChannel(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/changeOtpChannelType`);
    let resp = await axios.post(
      url,
      payload,
      { headers: header }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getProposalDocument(proposalId) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/productIllustration?proposalId=${proposalId}`);
    let resp = await axios.get(
      url,
      { headers: header }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getOccupationClass(occupationCode, NOBCode) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/master/occClass?nob=${NOBCode}&occ=${occupationCode}`);
    let resp = await axios.get(
      url,
      { headers: header }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getDeclarationQuestions(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/record/read/template?code=proposal_declarations`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async newProposal(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/new`);
    try {
      let resp = await axios.post(
        url,
        payload,
        {
          headers: header,

        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      console.log("error", error)
      return error;
    }

  }

  static async submitProposal(proposalData) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/submit?proposalId=${proposalData.id}`);
    let resp = await axios.post(
      url,
      {
        signature: proposalData.signatureContent,
        placeOfSigning: proposalData.placeOfSigning
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async fetchSubmitProposalStatus(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/fetchProposalSubmitStatus`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async submitProposalDocument(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/upload_document`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async submitForReviewResend(proposalId) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/submitForReview?proposalId=${proposalId}&isResend=true`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async submitForReview(proposalId, otpChannel) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/submitForReview?proposalId=${proposalId}&isResend=false&otpChannel=${otpChannel}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async saveFormProposal(id, category, payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/attr?category=${category}&proposalId=${id}`);
    try {
      let resp = await axios.post(
        url,
        payload,
        {
          headers: header,
        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      console.log("error", error)
      return error;
    }

  }

  static async deleteFormDataProposal(id, category, payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/attr?category=${category}&proposalId=${id}&active=false`);
    try {
      let resp = await axios.post(
        url,
        {},
        {
          headers: header,
        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      console.log("error", error)
      return error;
    }

  }

  static async getProposal(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/record/read/template?code=proposal_attr`);

    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,

      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getProposalDetails(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_ADVANCE_URL}/template?code=proposal_detail`);

    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,

      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getProposalByQuotationId(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/fetchProposalSummaryFromQuoId`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async deleteProposalUploadedFile(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/deleteUploadedDocument`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async completeReview(proposalId) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/client/completeReview?proposalId=${proposalId}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getClientSignature(proposalId) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/clientProposalSignature?proposalId=${proposalId}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      },
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async editProposal(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/edit?proposalId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }
}
